import { Getters, Mutations, Module, createMapper } from 'vuex-smart-module'
import Config from '@/config/config'

class NavBarTitleState {
  title = Config.systemTitle.fullName
  subTitle = ''
}

class NavBarTitleGetters extends Getters<NavBarTitleState> {
  get navBarTitle() {
    return this.state.title
  }
  get navBarSubTitle() {
    return this.state.subTitle
  }
  buildTitle(isMobile: boolean) {
    if (
      this.state.title === Config.systemTitle.fullName &&
      this.state.subTitle === Config.routing.authPage.name
    ) {
      if (isMobile) {
        return Config.systemTitle.shortName
      } else {
        return this.state.title
      }
    } else {
      if (isMobile) {
        return this.state.subTitle
      } else {
        return `${this.state.title}${
          this.state.subTitle ? '. ' + this.state.subTitle : this.state.subTitle
        }`
      }
    }
  }
}

class NavBarTitleMutations extends Mutations<NavBarTitleState> {
  setTitleFromRoute(info: any) {
    const firstPart = info.to.meta.group
    const secondPart = info.to.meta.displayName

    // Is Auth Page

    this.state.title = firstPart || Config.systemTitle.fullName
    this.state.subTitle = secondPart || ''
  }

  setTitle(text: string) {
    this.state.title = text
  }
  setSubTitle(text: string) {
    this.state.subTitle = text
  }
}

export const navBarTitle = new Module({
  state: NavBarTitleState,
  getters: NavBarTitleGetters,
  mutations: NavBarTitleMutations,
})

export const navBarTitleMapper = createMapper(navBarTitle)
